import { ChatType } from 'constants/chat-type';

export function getChatType(data: any) {
  if (data.supervised) {
    return ChatType.Supervised;
  }

  return ChatType.My;
}
